import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Compass } from 'lucide-react';
import Footer from '../components/Footer';
import { setPageSeo } from '../utils/seo';

export default function NotFoundPage() {
  useEffect(() => {
    setPageSeo({
      title: 'Not Found | Truffle Hunting Oregon',
      description: 'The page you requested is not part of the current Truffle Hunting Oregon guide.',
      path: '/404.html',
      robots: 'noindex,nofollow,noarchive',
    });
  }, []);

  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-xl text-center space-y-6">
          <Compass className="mx-auto text-accent" size={48} />
          <p className="text-[11px] uppercase tracking-widest text-ink-light font-bold">404</p>
          <h1 className="text-4xl md:text-5xl font-serif leading-[1.1]">
            You stepped off the Oregon route.
          </h1>
          <p className="text-ink-light leading-relaxed">
            That page is not part of the current truffle guide.
          </p>
          <div className="pt-2">
            <Link to="/" className="btn-minimal inline-flex items-center gap-2">
              <ArrowLeft size={14} /> Back to the route
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
